import React, { FC } from 'react'
import { useInView } from 'react-intersection-observer'
import { useGiveawayContext } from '../../context/GiveawayContext'
import TicketPackSection from '../TicketPack/TicketPackSection'
import { HowItWorks } from './HowItWorks'
import { PartnerLogosSection } from './PartnerLogosSection'

const MobileTicketSection: FC = () => {
  const { isActive, tickets, entryVariantId, mobileTicketContainerRef } = useGiveawayContext()

  const { ref: mobileProductRef } = useInView({ threshold: 0 })

  if (!isActive || !tickets || !entryVariantId) {
    return null
  }

  return (
    <TicketPackSection
      ref={mobileTicketContainerRef}
      className="w-full overflow-y-auto bg-white md:bg-[#F5F5F5] lg:hidden"
      mobileProductRef={mobileProductRef}
    />
  )
}

const ContentSections: React.FC = () => {
  const { content, isActive } = useGiveawayContext()
  const { steps, partnerLogosCollection, partnerText } = content

  if (!isActive) return null

  return (
    <div className="px-4 md:px-12">
      {steps && <HowItWorks className={partnerLogosCollection?.items.length ? '!pb-0' : undefined} steps={steps} />}
      {partnerLogosCollection?.items && (
        <PartnerLogosSection partnerLogos={partnerLogosCollection.items} text={partnerText} />
      )}
    </div>
  )
}

export const GiveawayContent: React.FC = () => {
  return (
    <>
      <MobileTicketSection />
      <ContentSections />
    </>
  )
}
